<template>
  <div
    class="retryable-wrapper"
    :style="handleWrapStyle"
    :class="{
      error: status === 'error' && !$slots.error,
      loading: status === 'loading' && !$slots.loading,
    }"
  >
    <!-- 错误状态 -->
    <slot name="error" v-if="status === 'error'">
      <div class="error-cont">
        <button v-if="refreshFn" @click="retry" class="refresh-btn">
          <img src="../../../assets/images/icon/refresh.png" alt="" />
        </button>
        <p class="tips">加载失败，点击重试</p>
      </div>
    </slot>

    <!-- 加载状态 -->
    <slot name="loading" v-else-if="status === 'loading'">
      <div class="loading-cont"></div>
    </slot>

    <!-- 成功状态 -->
    <div v-else>
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "RetryableWrapper",
  props: {
    status: {
      type: String,
      default: "loading",
    },
    refreshFn: {
      type: Function,
      default: () => {},
    },
    height: {
      type: Number,
      default: 70,
    },
  },
  data() {
    return {};
  },
  methods: {
    retry() {
      this.refreshFn();
    },
  },
  computed: {
    handleWrapStyle() {
      return {
        minHeight: `${this.height}px`,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.retryable-wrapper {
  &.loading {
    border-radius: 6px;
    background: rgba($color: #ffffff, $alpha: 0.7);
  }
  &.error {
    border-radius: 6px;
    background: rgba($color: #ffffff, $alpha: 0.7);
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .loading-cont {
    padding: 15px;
  }
  .error-cont {
    padding: 15px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .refresh-btn {
      width: 28px;
      height: 28px;
    }
    .tips {
      font-weight: 400;
      font-size: 12px;
      color: #0d1400;
      line-height: 22px;
      margin-top: 10px;
    }
  }
}
</style>
